module.exports = __webpack_public_path__ + "static/media/hs_23.8bdb86fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_23.jpg
// module id = 5953
// module chunks = 0